import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from '../authconfig';

export function useAuthFetch() {
    const { instance, accounts } = useMsal();

    const getToken = async () => {
        if (!accounts[0]) throw new Error('No authenticated account found.');
        try {
            const response = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            });
            return response.idToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect({ ...loginRequest, account: accounts[0] });
            }
            throw error;
        }
    };

    const authFetch = async (url, options = {}) => {
        const token = await getToken();
        return fetch(url, {
            ...options,
            headers: {
                ...options.headers,
                Authorization: `Bearer ${token}`,
            },
        });
    };

    // For axios calls (used in QuestionsList)
    const getAuthHeaders = async () => {
        const token = await getToken();
        return { Authorization: `Bearer ${token}` };
    };

    return { authFetch, getAuthHeaders };
}
